module.exports = __webpack_public_path__ + "img/potencia_r_c_blue.d2986019.svg";